import { render, staticRenderFns } from "./BalanceForm.vue?vue&type=template&id=3a08c754&"
import script from "./BalanceForm.vue?vue&type=script&lang=js&"
export * from "./BalanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports